var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebappFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#webapp_filter_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.503 1.873a61.591 61.591 0 0 0-13.006 0C1.692 2.06.555 3.902 1.414 5.5c1.382 2.575 3.353 4.962 6.118 6.757v4.903a1.428 1.428 0 0 0 1.998 1.31l2.078-.902c.522-.226.86-.741.86-1.31v-4.002c2.765-1.794 4.736-4.181 6.118-6.756.859-1.6-.435-3.456-2.083-3.628Z",
  stroke: "#3A434A",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "webapp_filter_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgWebappFilter;